import React from "react";
import { Link } from "react-router-dom";
import LegalLayout, { Section, Highlight } from "./LegalLayout";
import { LEGAL } from "./legalInfo";

export default function Terminos() {
    return (
        <LegalLayout
            title="Términos y Condiciones de Uso"
            intro={
                <Highlight>
                    <p className="font-semibold text-white mb-1">En resumen</p>
                    <p>
                        {LEGAL.marca}.mx es <strong>únicamente una plataforma tecnológica</strong> que
                        provee la <strong>interfaz</strong> para la venta de boletos. El{" "}
                        <strong>Organizador o promotor</strong> de cada evento es el{" "}
                        <strong>único responsable</strong> del evento y de todo lo relacionado con la
                        adquisición de boletos, reembolsos y cualquier aspecto económico.{" "}
                        {LEGAL.marca}.mx es responsable únicamente del{" "}
                        <strong>uso legal y la protección de tu información personal</strong>.
                    </p>
                </Highlight>
            }
        >
            <Section n={1} title="Aceptación de los Términos">
                <p>
                    Los presentes Términos y Condiciones (los “Términos”) regulan el acceso y uso de la
                    plataforma disponible en <a className="text-brand hover:underline" href={LEGAL.sitio}>{LEGAL.sitio}</a>{" "}
                    (el “Sitio” o la “Plataforma”), operada por {LEGAL.razonSocial} (“{LEGAL.marca}”), con
                    domicilio en {LEGAL.domicilio} y RFC {LEGAL.rfc}.
                </p>
                <p>
                    Al acceder, registrarse o realizar una compra en la Plataforma, usted (“Usuario”) acepta
                    de forma expresa estos Términos. Si no está de acuerdo, deberá abstenerse de utilizar la
                    Plataforma.
                </p>
            </Section>

            <Section n={2} title="Definiciones">
                <ul className="list-disc pl-5 space-y-2">
                    <li><strong>Organizador:</strong> persona física o moral responsable de producir, promover y realizar un evento, así como de definir las condiciones de venta, acceso, cancelación y reembolso de sus boletos.</li>
                    <li><strong>Comprador / Usuario:</strong> persona que adquiere uno o más boletos a través de la Plataforma.</li>
                    <li><strong>Boleto:</strong> documento digital (incluido su código QR) que acredita el derecho de acceso a un evento.</li>
                    <li><strong>Stripe:</strong> procesador de pagos a través del cual se realizan y liquidan las transacciones.</li>
                </ul>
            </Section>

            <Section n={3} title="Naturaleza del servicio y rol de Monoticket">
                <p>
                    {LEGAL.marca}.mx es una <strong>plataforma tecnológica intermediaria</strong> que pone a
                    disposición la <strong>interfaz</strong> para operar la taquilla de los eventos por cuenta
                    de los Organizadores. En consecuencia:
                </p>
                <ol className="list-decimal pl-5 space-y-2">
                    <li>{LEGAL.marca}.mx <strong>no es el organizador, productor, promotor ni vendedor</strong> del evento ni del bien o servicio subyacente.</li>
                    <li>El <strong>Organizador es el único responsable</strong> del evento: su realización, calidad, contenido, fechas, lugar, condiciones de acceso, y de todas las cuestiones <strong>económicas y legales</strong> relacionadas con la adquisición de boletos, incluyendo sus políticas de cancelación y reembolso.</li>
                    <li>{LEGAL.marca}.mx <strong>no custodia, administra ni dispone de dinero ajeno</strong>. Los pagos de los Compradores se procesan mediante Stripe y se <strong>depositan directamente en la cuenta de Stripe del Organizador</strong>. El control del dinero recae siempre en el Organizador.</li>
                    <li>La responsabilidad de {LEGAL.marca}.mx se limita a la provisión de la interfaz tecnológica y al <strong>tratamiento legal de los datos personales</strong> conforme a su Aviso de Privacidad.</li>
                </ol>
            </Section>

            <Section n={4} title="Registro de cuenta">
                <p>
                    Para ciertas funciones podrá ser necesario crear una cuenta. Usted se obliga a proporcionar
                    información veraz, completa y actualizada, y es responsable de mantener la confidencialidad
                    de sus credenciales y de toda actividad realizada bajo su cuenta. Notifique de inmediato
                    cualquier uso no autorizado.
                </p>
            </Section>

            <Section n={5} title="Proceso de compra de boletos">
                <ol className="list-decimal pl-5 space-y-2">
                    <li>El Comprador selecciona el evento y los boletos, y proporciona la información requerida.</li>
                    <li>El pago se realiza a través de <strong>Stripe</strong>. La compra se considera concluida una vez confirmado el pago.</li>
                    <li>El Boleto se entrega en formato digital al correo proporcionado y/o en la cuenta del Usuario.</li>
                    <li>Es responsabilidad del Comprador verificar los datos del evento (fecha, hora, lugar y condiciones) <strong>antes</strong> de completar la compra.</li>
                </ol>
            </Section>

            <Section n={6} title="Precios, comisiones y pagos">
                <ol className="list-decimal pl-5 space-y-2">
                    <li>Los precios de los boletos son fijados por el <strong>Organizador</strong> e incluyen los impuestos aplicables, salvo que se indique lo contrario.</li>
                    <li>La Plataforma podrá aplicar <strong>cargos por servicio o comisiones</strong> que se mostrarán de forma desglosada antes de confirmar la compra.</li>
                    <li>El procesamiento del pago lo realiza Stripe, sujeto a sus propios términos. {LEGAL.marca}.mx no almacena los datos completos de su medio de pago.</li>
                    <li>Dado que {LEGAL.marca}.mx no custodia los fondos, cualquier devolución se procesa a través del Organizador y/o de Stripe, conforme a la sección 8.</li>
                </ol>
            </Section>

            <Section n={7} title="Facturación (CFDI)">
                <p>
                    El Comprador podrá solicitar factura (CFDI) proporcionando sus datos fiscales dentro del
                    plazo y por los medios señalados en el Sitio. La emisión del CFDI corresponde al{" "}
                    <strong>Organizador</strong> del evento, salvo que se indique expresamente lo contrario.
                </p>
            </Section>

            <Section n={8} title="Cancelaciones, cambios y reembolsos">
                <ol className="list-decimal pl-5 space-y-2">
                    <li>Las políticas de cancelación y reembolso son definidas por el <strong>Organizador</strong> de cada evento y se informan al momento de la compra.</li>
                    <li>En caso de cancelación o modificación sustancial del evento, el Comprador tendrá los derechos que le otorga la <strong>Ley Federal de Protección al Consumidor</strong>, incluyendo, en su caso, el reembolso del monto pagado. El <strong>responsable de dicho reembolso es el Organizador</strong>.</li>
                    <li>Salvo disposición legal en contrario, los cargos por servicio podrían no ser reembolsables.</li>
                    <li>{LEGAL.marca}.mx prestará apoyo razonable para canalizar las solicitudes de reembolso, <strong>sin asumir la obligación de pago</strong>, la cual corresponde al Organizador.</li>
                </ol>
            </Section>

            <Section n={9} title="Uso del boleto y reventa">
                <ol className="list-decimal pl-5 space-y-2">
                    <li>El Boleto es <strong>personal</strong> y su uso indebido, duplicación o falsificación puede invalidarlo.</li>
                    <li>La <strong>reventa no autorizada</strong> de boletos, con o sin fines de lucro, queda <strong>prohibida</strong> y podrá dar lugar a la cancelación del Boleto, sin perjuicio de las disposiciones legales aplicables.</li>
                    <li>{LEGAL.marca}.mx y el Organizador podrán negar el acceso ante boletos inválidos, duplicados o adquiridos de forma fraudulenta.</li>
                </ol>
            </Section>

            <Section n={10} title="Conducta del Usuario">
                <p>El Usuario se obliga a no:</p>
                <ul className="list-disc pl-5 space-y-2">
                    <li>Utilizar la Plataforma con fines ilícitos o fraudulentos.</li>
                    <li>Vulnerar la seguridad del Sitio o interferir con su funcionamiento.</li>
                    <li>Suplantar la identidad de terceros o proporcionar información falsa.</li>
                    <li>Realizar compras automatizadas masivas (bots) o acaparamiento de boletos.</li>
                </ul>
            </Section>

            <Section n={11} title="Propiedad intelectual">
                <p>
                    Todos los derechos sobre la Plataforma, marcas, logotipos (incluido el de {LEGAL.marca}),
                    diseño, software y contenidos son propiedad de {LEGAL.marca} o de sus titulares y están
                    protegidos por la legislación aplicable. Queda prohibida su reproducción o uso sin
                    autorización previa y por escrito.
                </p>
            </Section>

            <Section n={12} title="Disponibilidad del servicio">
                <p>
                    {LEGAL.marca}.mx procurará la disponibilidad continua de la Plataforma, sin garantizar que
                    esté libre de interrupciones, errores o fallas. Podrá realizar mantenimientos o suspensiones
                    temporales que procurará notificar oportunamente.
                </p>
            </Section>

            <Section n={13} title="Limitación de responsabilidad">
                <p>En la máxima medida permitida por la ley:</p>
                <ol className="list-decimal pl-5 space-y-2">
                    <li>{LEGAL.marca}.mx <strong>no será responsable</strong> por la realización, calidad, suspensión, cancelación o cualquier incidencia del evento, ni por los reembolsos o aspectos económicos derivados de la compra, los cuales son responsabilidad exclusiva del Organizador.</li>
                    <li>{LEGAL.marca}.mx <strong>no será responsable</strong> por fallas, retrasos o errores atribuibles a Stripe, a los Organizadores o a terceros, ni por caso fortuito o fuerza mayor.</li>
                    <li>La responsabilidad de {LEGAL.marca}.mx, en lo que legalmente proceda, se limitará al monto de las comisiones efectivamente cobradas por {LEGAL.marca}.mx por la transacción de que se trate.</li>
                    <li>Nada en estos Términos limita los <strong>derechos irrenunciables</strong> que la legislación de protección al consumidor reconoce a su favor.</li>
                </ol>
            </Section>

            <Section n={14} title="Indemnización">
                <p>
                    El Usuario se obliga a sacar en paz y a salvo a {LEGAL.marca}, sus directivos y empleados,
                    frente a cualquier reclamación, daño o gasto derivado del incumplimiento de estos Términos o
                    del uso indebido de la Plataforma por parte del Usuario.
                </p>
            </Section>

            <Section n={15} title="Protección de datos personales">
                <p>
                    El tratamiento de datos personales se rige por el{" "}
                    <Link to="/privacidad" className="text-brand hover:underline">Aviso de Privacidad</Link>,
                    que forma parte integral de estos Términos. {LEGAL.marca}.mx es responsable del uso legal y
                    la protección de la información personal recabada a través de la Plataforma.
                </p>
            </Section>

            <Section n={16} title="Modificaciones a los Términos">
                <p>
                    {LEGAL.marca}.mx podrá modificar estos Términos en cualquier momento. Las modificaciones
                    surtirán efecto a partir de su publicación en el Sitio, indicando la fecha de actualización.
                    El uso continuado de la Plataforma implica la aceptación de los Términos vigentes.
                </p>
            </Section>

            <Section n={17} title="Legislación aplicable y jurisdicción">
                <p>
                    Estos Términos se rigen por las <strong>leyes de los Estados Unidos Mexicanos</strong>. Para
                    su interpretación y cumplimiento, las partes se someten a la jurisdicción de los tribunales
                    competentes de {LEGAL.ciudadEstado}, renunciando a cualquier otro fuero que pudiera
                    corresponderles.
                </p>
                <p>
                    Tratándose de relaciones de consumo, se respetarán los derechos del consumidor y la
                    competencia de la <strong>Procuraduría Federal del Consumidor (PROFECO)</strong>, sin que
                    dichos derechos puedan ser renunciados.
                </p>
            </Section>

            <Section n={18} title="Contacto">
                <p>
                    {LEGAL.marca} — {LEGAL.razonSocial}<br />
                    Correo: <a className="text-brand hover:underline" href={`mailto:${LEGAL.correoContacto}`}>{LEGAL.correoContacto}</a><br />
                    Domicilio: {LEGAL.domicilio}<br />
                    Sitio: <a className="text-brand hover:underline" href={LEGAL.sitio}>{LEGAL.sitio}</a>
                </p>
            </Section>
        </LegalLayout>
    );
}
